import React from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/error/error-3.scss";

export function ErrorPage7() {
	return (
		<>
			<div className="kt-grid kt-grid--ver kt-grid--root">
				<div className="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v3"
					style={{
						backgroundImage: `url(${toAbsoluteUrl(
							"/media/error/bg5.jpg"
						)})`
					}}>
					<div className="kt-error_container">
						<div className="kt-error_number">
							<h1>402</h1>
						</div>
						<p className="kt-error_title kt-font-dark">Ocorreu um problema com o seu pagamento.</p>
						<p className="kt-error_subtitle">
							Verifique os dados de cobrança.
						</p>
						<p className="kt-error_description">
							Fale com o seu administrador.
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
